export const TRANSLATIONS_MN = {
    file: {
        sizeError: 'Файлын хэмжээ их байна',
        typeError: 'Файлын төрөл буруу байна',
        imageTypeError: 'Зургийн төрөл буруу байна',
        videoTypeError: 'Видеоны төрөл буруу байна'
    }
}